import { Injectable } from '@angular/core';
import { EndpointService } from './endpoint.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AgentGroupOrgLevel } from '../models/agentGroupOrglevel.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgentGroupOrgLevelService extends EndpointService {

  constructor(http: HttpClient) {
    super(http);
  }

  create(payload: AgentGroupOrgLevel) {
    return this.http.post(this.getApiUrl('AgentGroupOrgLevel/Create'), payload);
  }

  getAssociations(agentGroupId: string, parentOrgLevelId: string, orgLevelType?: number): Observable<AgentGroupOrgLevel[]> {
    let params = new HttpParams()
      .set('agentGroupId', agentGroupId.toString());
      if (parentOrgLevelId !== undefined && parentOrgLevelId !== null) {
      params = params.set('parentOrgLevelId', parentOrgLevelId.toString());
    } else if (orgLevelType !== undefined && orgLevelType !== null) {
      params = params.set('orgLevelType', orgLevelType.toString());
    }

    return this.http.get<AgentGroupOrgLevel[]>(this.getApiUrl('AgentGroupOrgLevel/GetAssociations'), { params });
  }

  delete(agentGroupId: string, orgLevelId: string): Observable<Object> {
    const params = new HttpParams()
      .set('agentGroupId', agentGroupId.toString())
      .set('organizationLevelId', orgLevelId.toString());

    return this.http.delete(this.getApiUrl('AgentGroupOrgLevel/Delete'), { params });
  }
}
